/**
 * Ceiling on one await, so a promise that never settles becomes a failure the
 * caller already knows how to handle.
 *
 * Жил в `useChatThreadSource` (там его завели вместе с дедлайном на открытие
 * чата) и переехал сюда, когда тот же приём понадобился внутри самого канала:
 * сервис не должен импортировать хук ради одной функции. Хук по-прежнему
 * экспортирует то же имя, поэтому у прежних вызовов ничего не поменялось.
 */

/**
 * CORE-1020 — отдельный тип для срыва по времени.
 *
 * Отличать его от прочих отказов обязательно. «Модерация не пропустила»,
 * «нечего отправлять», «сокет не подключён» — это ответы, они означают, что
 * связь как раз работает. Реагировать на них так же, как на молчание, значит
 * рвать здоровое соединение из-за пустого сообщения.
 */
export class DeadlineExceededError extends Error {
  constructor(public readonly what: string, public readonly ms: number) {
    super(`chat connect: ${what} exceeded ${ms} ms`);
    this.name = 'DeadlineExceededError';
  }
}

/** Reject if `p` has not settled within `ms`. The loser of the race is left to
 *  finish on its own — the caller disconnects the half-open source. */
export function withDeadline<T>(p: Promise<T>, ms: number, what: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new DeadlineExceededError(what, ms)),
      ms,
    );
    p.then(
      (v) => { clearTimeout(timer); resolve(v); },
      (e) => { clearTimeout(timer); reject(e); },
    );
  });
}
